import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChessQueen } from 'react-icons/fa';
import { Button } from '../ui/button';

export function PuzzlePanel({ title, children }) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm">
      <h2 className="mb-4 text-base font-semibold text-slate-800">{title}</h2>
      {children}
    </section>
  );
}

export default function PuzzleWorkspace({ title, subtitle, backTo = '/', backLabel = 'Back to home', showBack = true, onBack, backDisabled = false, backIcon: BackIcon = FaArrowLeft, toolbar, sidebar, contentLabel = 'Puzzle board and controls', children }) {
  const Brand = onBack ? 'span' : Link;
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <header className="flex w-full flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6">
        <div className="min-w-0 flex-1 basis-40 text-left">
          <Brand {...(!onBack && { to: '/' })} className="inline-flex items-center gap-2 text-lg font-bold text-[#247da8]">
            <FaChessQueen aria-hidden="true" /> Puzzlify
          </Brand>
          <h1 className="mb-0 mt-2 text-xl font-bold tracking-tight sm:text-2xl">{title}</h1>
          {subtitle && <p className="mb-0 mt-1 text-sm text-slate-600">{subtitle}</p>}
        </div>
        {(toolbar || showBack) && <nav aria-label="Puzzle navigation" className="flex shrink-0 gap-2">
          {toolbar}
          {showBack && (onBack ? (
            <Button variant="brand" size="action" className="m-0 w-12 p-0" onClick={onBack} disabled={backDisabled} aria-label={backLabel} title={backLabel}>
              <BackIcon aria-hidden="true" />
            </Button>
          ) : (
            <Button asChild variant="neutral" size="action" className="m-0 w-12 p-0">
              <Link to={backTo} aria-label={backLabel} title={backLabel}><FaArrowLeft aria-hidden="true" /></Link>
            </Button>
          ))}
        </nav>}
      </header>
      <main className={`grid w-full items-start gap-6 pb-8 sm:px-6 ${sidebar ? 'lg:grid-cols-[minmax(0,1fr)_20rem] xl:grid-cols-[minmax(0,1fr)_minmax(30rem,0.75fr)]' : ''}`}>
        <section aria-label={contentLabel} className="min-w-0">{children}</section>
        {sidebar && <aside aria-label="Puzzle information" className="min-w-0 space-y-4 px-4 sm:px-0">{sidebar}</aside>}
      </main>
    </div>
  );
}
